/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkCopropertyToRiskRequest
 */
export interface LinkCopropertyToRiskRequest {
    /**
     * 
     * @type {string}
     * @memberof LinkCopropertyToRiskRequest
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof LinkCopropertyToRiskRequest
     */
    copropertyId: string;
}

/**
 * Check if a given object implements the LinkCopropertyToRiskRequest interface.
 */
export function instanceOfLinkCopropertyToRiskRequest(value: object): value is LinkCopropertyToRiskRequest {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('copropertyId' in value) || value['copropertyId'] === undefined) return false;
    return true;
}

export function LinkCopropertyToRiskRequestFromJSON(json: any): LinkCopropertyToRiskRequest {
    return LinkCopropertyToRiskRequestFromJSONTyped(json, false);
}

export function LinkCopropertyToRiskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkCopropertyToRiskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'copropertyId': json['copropertyId'],
    };
}

export function LinkCopropertyToRiskRequestToJSON(json: any): LinkCopropertyToRiskRequest {
    return LinkCopropertyToRiskRequestToJSONTyped(json, false);
}

export function LinkCopropertyToRiskRequestToJSONTyped(value?: LinkCopropertyToRiskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'copropertyId': value['copropertyId'],
    };
}

